/* eslint-disable import/newline-after-import, import/first */

//region 1. Platform Libraries
import { assert } from 'chai';
import {
        connect,
        createObjectId,
} from 'pow-mongodb-fixtures';
import mongodbURI from 'mongodb-uri';
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route .../video-info', () => {
        const mongo = mongodbURI.parse(process.env.CLIO_MONGO_URL);
        const fixtures = connect(mongo.database, {
                host: mongo.hosts[0].host,
                port: mongo.hosts[0].port,
                user: mongo.username,
                pass: mongo.password,
        });
        const dataAPI = new DataAPI();
        const id = '123456789a123456789b1234';
        const indexWithoutVideoInfo = 0;
        const indexWithVideoInfo = 1;
        const dummyVideoInfoDB = {
                index: 1,
                start_time: 1482375835000,
                end_time: 1482375845000,
                bucket_name: 'bucket-name',
                object_name: 'object/name',
        };
        const dummyVideoInfo2REST = {
                index: 2,
                startTime: 2482375835000,
                endTime: 2482375845000,
                bucketName: 'bucket-name',
                objectName: 'object/name',
        };

        before(function before(done) {
                this.timeout(5000);
                fixtures.clearAllAndLoad({
                        cameras: [{
                                _id: createObjectId(id),
                                streams: {
                                        0: {},
                                        1: {
                                                video_info: [dummyVideoInfoDB],
                                        },
                                },
                        }],
                }, (err) => {
                        if (err) {
                                throw new Error(err.message);
                        }
                        dataAPI.initialize({
                                environment: 'unit-test',
                                heartbeatInterval: 10,
                                logLevel: 'DEBUG',
                                mongoUrl: process.env.CLIO_MONGO_URL,
                                port: 15925,
                        });
                        dataAPI.start(done);
                });
        });

        it('PUT video info should succeed', (done) => {
                request(dataAPI.expressApp)
                .put(`/cameras/${id}/streams/${indexWithVideoInfo}/video-info`)
                .send(dummyVideoInfo2REST)
                .expect(200)
                .end(/** @type function */done);
        });

        it('GET empty video info array should succeed', (done) => {
                request(dataAPI.expressApp)
                .get(`/cameras/${id}/streams/${indexWithoutVideoInfo}/video-info/-1`)
                .expect(200)
                .expect(res => assert.deepEqual({ index: 0 }, res.body))
                .end(/** @type function */done);
        });

        it('GET second video info should succeed', (done) => {
                request(dataAPI.expressApp)
                .get(`/cameras/${id}/streams/${indexWithVideoInfo}/video-info/-1`)
                .expect(200)
                .expect(res => assert.deepEqual(dummyVideoInfo2REST, res.body))
                .end(/** @type function */done);
        });

        after(done => dataAPI.stop(done));
});
